export const common = {
  download: 'Download',
  loading: 'Loading...',
  save: 'Save',
  saving: 'Saving...',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  create: 'Create',
  creating: 'Creating...',
  update: 'Update',
  updating: 'Updating...',
  search: 'Search...',
  logout: 'Logout',
  close: 'Close',
  copy: 'Copy',
  copied: 'Copied',
  copyFailed: 'Failed to copy',
  noData: 'No data to display',
  error: 'Error',
  reload: 'Reload',
  refresh: 'Refresh',
  select_language: 'Select language',
  dateFilter: 'Filter by Date',
  showing: 'Showing {{count}} entries',
  exportExcel: 'Export to Excel',
  inDevelopment: 'Under Development',
  whatsNew: 'Latest Improvements',
  version: 'Version',
  yes: 'Yes',
  no: 'No',
  active: 'Active',
  inactive: 'Inactive',
  invalidDate: 'Invalid date',
  all: 'All',
  status: 'Status',
  approve: 'Approve',
  approved: 'Approved',
  errors: {
    loadingFailed: 'Failed to load data. Please try again.',
    saveFailed: 'Failed to save. Please try again.',
    pageNotFound: {
      title: 'Page Not Found',
      description: 'The page you are looking for does not exist or has been moved. Please check the URL or return to the homepage.',
      quickLinks: 'Quick links:'
    }
  },
  validation: {
    required: 'This field is required'
  },
  modules: {
    disabled: 'Disabled module',
    premium: 'Premium feature',
    status: 'Module status'
  },
  actions: 'Actions',
  tableView: 'Table View',
  cardView: 'Card View',
  view: 'View',
  actionsObject: {
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    create: 'Create',
    view: 'View',
    close: 'Close',
    share: 'Share',
    refresh: 'Refresh'
  },
  buttons: {
    save: 'Save',
    cancel: 'Cancel',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    close: 'Close',
    submit: 'Submit',
    update: 'Update',
    view: 'View',
    back: 'Back',
    backToBuilder: 'Back to Form Builder',
    next: 'Next',
    previous: 'Previous',
    add: 'Add',
    remove: 'Remove',
    confirm: 'Confirm',
    retry: 'Retry'
  },
  back: 'Back',
  next: 'Next',
  confirmDelete: 'Are you sure you want to delete this item?',
  profile: {
    title: 'Profile Settings',
    subtitle: 'Manage personal and organization information',
    personalInfo: 'Personal Information',
    fullName: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    organization: 'Organization Details',
    organizationName: 'Organization Name',
    taxNumber: 'Tax Number',
    registrationNumber: 'Registration Number',
    organizationStatus: 'Organization Status',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    updatePassword: 'Update Password'
  },
  messages: {
    profile: {
      updateSuccess: 'Profile updated successfully',
      updateError: 'Error updating profile',
      passwordMismatch: 'Passwords do not match',
      passwordChangeSuccess: 'Password changed successfully',
      passwordChangeError: 'Error changing password',
      passwordTooShort: 'Password must be at least 6 characters long',
      wrongPassword: 'Current password is incorrect',
      weakPassword: 'Password is too weak'
    },
    linkCopied: 'Link copied to clipboard',
    shareError: 'Error sharing link',
    authContext: {
      error: 'Error loading user data',
      signInSuccess: 'Sign in successful!',
      signInError: 'Sign in failed',
      signOutSuccess: 'Sign out successful!',
      signOutError: 'Sign out failed',
      invalidCredentials: 'Invalid email or password',
      userDisabled: 'This user account is disabled',
      tooManyRequests: 'Too many failed attempts. Please try again later'
    },
    customer: {
      failedToLoad: 'Error loading customers',
      createdSuccess: 'Customer created successfully',
      createdError: 'Error creating customer',
      updatedSuccess: 'Customer updated successfully',
      updatedError: 'Error updating customer',
      deletedSuccess: 'Customer deleted successfully',
      deletedError: 'Error deleting customer',

      customerStatusUpdated: 'Customer status updated: ',
      customerStatusUpdateFailed: 'Error updating customer status'
    },
    quotation: {
      createSuccess: 'Quotation created successfully',
      createError: 'Error creating quotation',
      offerStatusUpdated: 'Quotation status updated: ',
      offerStatusUpdateFailed: 'Error updating quotation status',
      updateStatus: "Click to modify status"
    },
    organization: {
      emailNotFound: 'No user found with this email',
      userAlreadyExists: 'This user is already a member of this organization',
      userAdded: 'User added successfully',
      userInvited: 'User invited successfully',
      userAddError: 'Error adding user',
      userRemoved: 'User removed successfully',
      userRemoveError: 'Error removing user',

      createdSuccess: 'Organization created successfully',
      createdError: 'Error creating organization',
      updateSuccess: 'Organization updated successfully',
      updateError: 'Error updating organization',
      deleteSuccess: 'Organization deleted successfully',
      deleteError: 'Error deleting organization',

      logoUploadSuccess: 'Logo uploaded successfully',
      logoUploadError: 'Error uploading logo',
      logoDeleteSuccess: 'Logo removed successfully',
      logoDeleteError: 'Error removing logo',
    },
    copyError: 'Error copying link',
    documentGenerationStarted: 'Document generation started:'
  },
  placeholders: {
    selectOrg: 'Select organization...',
    selectOrganization: 'Select organization...',
    selectCustomer: 'Select customer...',
    selectProduct: 'Select product...',
    selectQuotation: 'Select quotation...',
    notes: 'Additional notes for the quotation...',
    itemNotes: 'Note for this item...',
    quotationNotes: 'General notes for the quotation...',
    email: 'Email address...',
    unitPlaceholder: 'e.g.: piece, hour, day',
    deals: "Search deals (description, subject, customer, assignee)..."
  },
  page: {
    notFound: 'Page not found',
    returnToDashboard: 'Return to Dashboard'
  },
  settings: {
    title: 'Settings',
    subtitle: 'System settings and configuration',
    organizations: 'Organizations'
  },
  pagination: {
    showing: 'Showing',
    itemsPerPage: 'items/page',
    of: 'of',
    to: 'to',
    results: 'results'
  },
  accept: 'Accept',
  deny: 'Deny',
  add: 'Add',
  remove: 'Remove',
  uploading: 'Uploading...',
  modifiedBy: 'Modified by',
  submit: 'Submit',
  submitting: 'Submitting...',
  createdAt: 'Created',
  updatedAt: 'Updated',
  createdBy: 'Created by',
  filters: 'Filters',
  reset: 'Reset',
  readOnlyMode: 'Read-only view',
  shortcuts: {
    ctrlEnter: 'Ctrl+Enter to save'
  },
  backToHome: 'Back to Home',
  backToPortal: 'Back to Portal',
  nav: {
    customers: 'Customers',
    projects: 'Projects',
    deals: 'Deals',
    tasks: 'Tasks'
  }
};